module.exports = __webpack_public_path__ + "img/dance-school-icon4.41ba1314.png";